import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'

export default {
    name: 'LatestOrders',
    data,
    methods,
    mounted
}
